// frontend/src/utils/contentAvailability.js

// List of currently available itinerary slugs (derived from our dataset)
const availableItineraries = [
  "bali", "europe", "japan-classic", "australia-roadtrip", "peru-discovery", "thai-islands",
  "kenya-safari", "california-coast", "delhi", "goa", "kashmir-valley", "rajasthan-royal",
  "kerala-backwaters", "himachal-adventure", "golden-triangle", "goa-quick-break",
  "north-east-explorer", "varanasi-spiritual", "kashmir-paradise", "andaman-islands",
  "swiss-alps", "everest-base-camp", "inca-trail", "patagonia-wilderness", "mount-fuji",
  "dolomites", "rocky-mountains", "kilimanjaro", "annapurna-circuit", "mount-cook",
  "amritsar", "udaipur", "sikkim-gangtok", "rishikesh", "ladakh", "iceland-ring-road",
  "santorini", "london-edinburgh", "south-africa-safari", "thailand-cultural", "triund-trek",
  "kedarkantha", "torres-del-paine", "mount-elbrus", "pondicherry", "phuket", "hawaii",
  "dubai", "petra-wadi-rum", "marrakech-atlas", "nile-cruise", "istanbul", "bora-bora",
  "alaska-wilderness", "amazon-rainforest", "buenos-aires", "galapagos", "transylvania",
  "norwegian-fjords", "sri-lanka", "seoul-busan", "cape-town", "bhutan", "uzbekistan-silk-road",
  "faroe-islands", "antarctica-expedition", "yucatan", "vienna", "prague", "budapest",
  "scotland-highlands", "cinque-terre", "croatia-islands", "montenegro", "balkan-capitals",
  "lapland", "baltic-capitals", "georgia-caucasus", "armenia", "kazakhstan", "mongolia-nomad",
  "angkor", "laos", "philippines", "taiwan", "namibia-desert", "zanzibar", "western-australia",
  "tasmania", "quebec-city", "panama-canal", "costa-rica"
];

// List of currently available blog slugs from our dataset / API
const availableBlogs = [
  "golden-temple-food-tour",
  "slow-travel-in-darjeeling",
  "amritsar-travel-guide",
  "amritsar",
  "dubai-travel-guide",
  "paris-travel-guide",
  "tokyo-travel-guide",
  "bali-travel-guide"
];

/**
 * Checks if a blog exists for the given slug
 * @param {string} slug - The slug to check
 * @returns {boolean} true if the blog is available
 */
export const hasBlog = (slug) => {
  if (!slug) return false;
  // Support both explicit slugs and city slugs dynamically mapped to guides
  const searchSlug = slug.endsWith('-travel-guide') ? slug : `${slug}-travel-guide`;
  return availableBlogs.includes(slug) || availableBlogs.includes(searchSlug);
};

/**
 * Checks if an itinerary exists for the given slug
 * @param {string} slug - The slug to check
 * @returns {boolean} true if the itinerary is available
 */
export const hasItinerary = (slug) => {
  if (!slug) return false;
  return availableItineraries.includes(slug);
};
